import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 愿望单列表
export const setFavorites: Mutation<IModuleState> = (state, payload) => {
  state.list.data = payload.data;
  state.list.pageNum = payload.pageNum;
  state.list.pageSize = payload.pageSize;
  state.list.total = payload.total;
  state.list.loading = !!payload.loading;
};

// 子列表
export const setSubList: Mutation<IModuleState> = (state, payload) => {
  state.sublist.data = payload.data || [];
  state.sublist.loading = !!payload.loading;
};

// 组织列表
export const setOrgs: Mutation<IModuleState> = (state, payload) => {
  state.orgs.data = payload.data;
  state.orgs.loading = !!payload.loading;
};

// 用户列表
export const setUsers: Mutation<IModuleState> = (state, payload) => {
  state.users.data = payload.data;
  state.users.loading = !!payload.loading;
};

// 确认弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = !!payload;
};
